export default {
  feedback: {
    success: 'Application mobile enregistrée',
    error: "Échec de l'enregistrement de l'application mobile",
  },
};
